<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh;">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index: 1" extended>
        <v-toolbar-title v-if="!$vuetify.breakpoint.xsOnly">Comunidad</v-toolbar-title>
        <v-toolbar-title v-show="$vuetify.breakpoint.xsOnly" style="width:100%">
          <v-flex class="titleSearch">
            <v-text-field
              class="mt-3"
              flat
              label="Comunidad"
              append-outer-icon="search"
              @click:append-outer="filterSearch"
              @click:clear="filterSearch"
              @keyup.enter="filterSearch"
              solo-inverted
              v-model="filters.search"
              clearable
            ></v-text-field>
          </v-flex>
        </v-toolbar-title>
        <v-layout
          wrap
          justify-space-around
          fill-height
          align-center
          v-if="!$vuetify.breakpoint.xsOnly"
        >
          <v-flex xs12 sm6 md3>
            <v-menu
              ref="dateMenu2"
              v-model="dateMenu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              :close-on-content-click="false"
              :return-value.sync="dates"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  @input="filterDate"
                  v-model="dates"
                  multiple
                  chips
                  small-chips
                  label="Fechas"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-combobox>
                <!-- <v-text-field
                  @input="filterDate"
                  id="first"
                  :value="momentFormatFirst"
                  label="Fecha"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  outline
                ></v-text-field>-->
              </template>
              <v-date-picker
                header-color="primary"
                color="secondary"
                locale="es-419"
                v-model="dates"
                scrollable
                multiple
                no-title
                :allowed-dates="allowedDatesF"
                @input="filterDate"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="dateMenu = false">Cancelar</v-btn>
                <v-btn flat color="primary" @click="$refs.dateMenu2.save(dates)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-select
              @input="filterType"
              :items="types"
              v-model="filters.typeNotice"
              item-value="value"
              item-text="text"
              multiple
              label="Tipo de comunicado"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-tooltip right v-if="permits['WATCH_NOTICE'] && permits['ADD_NOTICE']">
          <v-btn
            color="gradiente"
            dark
            small
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="modals.createNotice = true;"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear comunicado</span>
        </v-tooltip>

        <template v-slot:extension>
          <v-layout row wrap>
            <v-flex
              xs12
              sm6
              xl4
              offset-xl4
              offset-sm3
              v-show="!$vuetify.breakpoint.xsOnly"
              class="titleSearch"
            >
              <v-text-field
                class="mx-3"
                flat
                label="Buscar"
                append-outer-icon="search"
                @click:append-outer="filterSearch"
                @click:clear="filterSearch"
                @keyup.enter="filterSearch"
                clearable
                solo-inverted
                v-model="filters.search"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap row v-if="$vuetify.breakpoint.xsOnly">
            <v-flex xs6 sm6 md3>
              <v-menu
                ref="dateMenu1"
                v-model="dateMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <!-- <v-text-field
                    @input="filterDate"
                    id="first"
                    :value="momentFormatFirst"
                    label="Fecha"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    outline
                  ></v-text-field>-->
                  <v-combobox
                    @input="filterDate"
                    v-model="dates"
                    multiple
                    chips
                    small-chips
                    label="Fechas"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-combobox>
                </template>
                <v-date-picker
                  header-color="primary"
                  color="secondary"
                  locale="es-419"
                  v-model="dates"
                  scrollable
                  multiple
                  no-title
                  :allowed-dates="allowedDatesF"
                  @input="filterDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="dateMenu = false">Cancelar</v-btn>
                  <v-btn flat color="primary" @click="$refs.dateMenu1.save(dates)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm6 md3>
              <v-select
                @input="filterType"
                :items="types"
                v-model="filters.typeNotice"
                label="Tipo"
                item-value="value"
                item-text="text"
                multiple
              ></v-select>
            </v-flex>
          </v-layout>
        </template>
      </v-toolbar>
      <v-container fluid elevation-2 style="max-height: 75vh;" class="scrollDesign" grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            :sm9="permits['CONFIRM_NOTICE']"
            :md10="permits['CONFIRM_NOTICE']"
            :lg10="permits['CONFIRM_NOTICE']"
          >
            <v-data-iterator
              :pagination.sync="pagination"
              :total-items="totalNotices"
              :rows-per-page-items="[25, 50, 100]"
              :items="notices"
              item-key="id"
              content-tag="v-layout"
              :no-data-text="permits['WATCH_NOTICE'] ? (notices.length > 0 ? '' : 'No hay comunicados') : 'No tienes permiso de ver comunicados'"
              no-results-text="No hay comunicados"
              rows-per-page-text="Registros por página"
              row
              wrap
              expand
            >
              <template v-slot:item="props">
                <v-flex xs12 sm10 md5 lg4 xl3>
                  <v-hover>
                    <v-card slot-scope="{ hover }" class="expandableContainer elevation-0">
                      <v-img
                        v-if="props.item.imageStorage.length > 0"
                        height="223"
                        :src="props.item.imageStorage[0].miniObjUrl"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out primary v-card--reveal display-3 white--text"
                            style="height: 100%;"
                          >
                            <v-btn
                              @click="viewNotice(props.item)"
                              flat
                              style="width: 100%; height: 100%; margin:0;"
                            >
                              <v-icon large>remove_red_eye</v-icon>
                            </v-btn>
                          </div>
                        </v-expand-transition>
                      </v-img>
                      <v-img
                        height="223"
                        v-else-if="props.item.type == 'A'"
                        :src="require('@/assets/notices/SKLB-Aviso 3.png')"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out primary v-card--reveal display-3 white--text"
                            style="height: 100%;"
                          >
                            <v-btn
                              @click="viewNotice(props.item)"
                              flat
                              style="width: 100%; height: 100%; margin:0;"
                            >
                              <v-icon large>remove_red_eye</v-icon>
                            </v-btn>
                          </div>
                        </v-expand-transition>
                      </v-img>
                      <v-img
                        height="223"
                        v-else-if="props.item.type == 'E'"
                        :src="require('@/assets/notices/SKLB-Evento.png')"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out primary v-card--reveal display-3 white--text"
                            style="height: 100%;"
                          >
                            <v-btn
                              @click="viewNotice(props.item)"
                              flat
                              style="width: 100%; height: 100%; margin:0;"
                            >
                              <v-icon large>remove_red_eye</v-icon>
                            </v-btn>
                          </div>
                        </v-expand-transition>
                      </v-img>
                      <v-img
                        height="223"
                        v-else-if="props.item.type == 'R'"
                        :src="require('@/assets/notices/SKLB-informe.png')"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out primary v-card--reveal display-3 white--text"
                            style="height: 100%;"
                          >
                            <v-btn
                              @click="viewNotice(props.item)"
                              flat
                              style="width: 100%; height: 100%; margin:0;"
                            >
                              <v-icon large>remove_red_eye</v-icon>
                            </v-btn>
                          </div>
                        </v-expand-transition>
                      </v-img>
                      <v-img
                        height="223"
                        v-else-if="props.item.type == 'P'"
                        :src="require('@/assets/notices/SKLB-Permiso.png')"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out primary v-card--reveal display-3 white--text"
                            style="height: 100%;"
                          >
                            <v-btn
                              @click="viewNotice(props.item)"
                              flat
                              style="width: 100%; height: 100%; margin:0;"
                            >
                              <v-icon large>remove_red_eye</v-icon>
                            </v-btn>
                          </div>
                        </v-expand-transition>
                      </v-img>
                      <v-card-title>
                        <div class="text-truncate" style="width: 75%;">
                          <b>{{ props.item.title }}</b>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn @click="props.expanded = !props.expanded" icon>
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </v-card-title>

                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-alert
                          class="statusEvent"
                          outline
                          v-if="props.item.cancelled || props.item.confirm == 'C'"
                          :value="true"
                          type="error"
                        ><span class="semi-small">Cancelado</span></v-alert>
                        <v-alert
                          class="statusEvent"
                          outline
                          v-else-if="props.item.confirm == 'A'"
                          :value="true"
                          type="success"
                        ><span class="semi-small">Autorizado</span></v-alert>
                        <v-alert
                          class="statusEvent"
                          outline
                          v-if="props.item.confirm == 'P'"
                          :value="true"
                          type="warning"
                        ><span class="semi-small">Autorización pendiente</span></v-alert>
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="historyNotice(props.item)"
                          icon
                          v-if="permits['WATCH_NOTICE'] && !props.item.cancelled"
                        >
                          <v-icon>history</v-icon>
                        </v-btn>
                        <v-btn
                          @click="editNotice(props.item)"
                          icon
                          v-if="permits['UPDATE_NOTICE'] && !props.item.cancelled && props.item.confirm !== 'C'"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          @click="cancelNotice(props.item)"
                          v-if="!props.item.cancelled && props.item.type == 'E'"
                        >
                          <v-icon color="primary">cancel</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="permits['DELETE_NOTICE']"
                          icon
                          @click="modals.confirm = true; selected.dNotice = props.item;"
                        >
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                      <v-expand-transition>
                        <v-list v-if="props.expanded" dense>
                          <v-list-tile>
                            <v-list-tile-content>Tipo:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-chip>
                                <v-avatar>
                                  <img
                                    v-if="props.item.type == 'A'"
                                    :src="require('@/assets/notices/aviso.png')"
                                  />
                                  <img
                                    v-else-if="props.item.type == 'E'"
                                    :src="require('@/assets/notices/evento.png')"
                                  />
                                  <img
                                    v-else-if="props.item.type == 'R'"
                                    :src="require('@/assets/notices/informe.png')"
                                  />
                                  <img
                                    v-else-if="props.item.type == 'P'"
                                    :src="require('@/assets/notices/permiso.png')"
                                  />
                                </v-avatar>
                                {{ props.item.type | noticeTypeFilter }}
                              </v-chip>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Confirmación del Tutor:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-icon v-if="props.item.confirmParent" color="green">check_circle</v-icon>
                              <v-icon v-else color="red">cancel</v-icon>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Fecha:</v-list-tile-content>
                            <v-list-tile-content
                              class="align-end"
                            >{{ props.item.createdAt | dateFormat}}</v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="props.item.type == 'E'">
                            <v-list-tile-content>Fecha inicio:</v-list-tile-content>
                            <v-list-tile-content
                              class="align-end"
                            >{{ props.item.startDate | dateFormat2}}</v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="props.item.type == 'E' && props.item.endDate != null">
                            <v-list-tile-content>Fecha término:</v-list-tile-content>
                            <v-list-tile-content
                              class="align-end"
                            >{{ props.item.endDate | dateFormat2}}</v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Creador:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-chip>
                                <v-avatar>
                                  <img
                                    v-if="props.item.employee.img != null && props.item.employee.img != ''"
                                    :src="'data:image/jpg;base64, ' +props.item.employee.img"
                                  />
                                  <v-icon v-else color="gray lighten-4">person</v-icon>
                                </v-avatar>
                                {{ props.item.employee.firstName + ' ' + props.item.employee.lastName}}
                              </v-chip>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Rol:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-chip>
                                <v-avatar>
                                  <v-icon color="primary">security</v-icon>
                                </v-avatar>
                                {{ props.item.employee.rol.name}}
                              </v-chip>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-expand-transition>
                    </v-card>
                  </v-hover>
                </v-flex>
              </template>
              <template
                v-slot:pageText="props"
              >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
            </v-data-iterator>
          </v-flex>
          <v-flex v-show="permits['CONFIRM_NOTICE']" sm3 md2 lg2 xl2>
            <ConfirmNoticeSection
              @success="toast.success = true; getNotices();"
              @failed="toast.failed = true;"
              @watchNotice="searchNotice($event)"
              @loading="flags.loading = $event"
            ></ConfirmNoticeSection>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <loading v-model="flags.loading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <CreateNotice
      v-on:loading="flags.loading = true;"
      v-on:success="flags.loading = false; toast.success = true;getNotices();"
      v-on:failed="flags.loading = false; toast.failed = true;"
      v-model="modals.createNotice"
    ></CreateNotice>
    <confirm
      title="Eliminar"
      description="¿Estas seguro que deseas eliminar este comunicado?"
      v-model="modals.confirm"
      v-on:desition="$event ? deleteNotice() : ''"
    ></confirm>
    <WatchNotice v-model="modals.watch" :notice="selected.wNotice"></WatchNotice>
    <EditNotice v-model="modals.edit" :notice="selected.eNotice"></EditNotice>
    <NoticeHistory v-model="modals.history" :notice="selected.eNotice"></NoticeHistory>
  </v-container>
</template>

<script>
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import moment from "moment";
import confirm from "../../Dialogs/Confirm";
import CreateNotice from "../../Modals/CreateNotice.vue";
import WatchNotice from "../../Modals/WatchNotice";
import EditNotice from "../../Modals/EditNotice";
import NoticeHistory from "../../Modals/NoticeHistory";
import ConfirmNoticeSection from "../../Sections/Notices/ConfirmationSectionNotice";
import { mapGetters } from "vuex";
export default {
  components: {
    success,
    error,
    loading,
    CreateNotice,
    confirm,
    WatchNotice,
    EditNotice,
    NoticeHistory,
    ConfirmNoticeSection
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits();
      if (!this.permits["WATCH_NOTICE"]) {
        this.toast.failed = true;
      } else {
        if (this.notices.length == 0) {
          this.getNotices();
        }
      }
    }
  },
  watch: {
    dates() {
      this.filters.dates = [];
      for (let t of this.dates) {
        var d = new Date(t);
        this.filters.dates.push(d.getTime());
      }
    },
    pagination: {
      handler() {
        if (this.permits["WATCH_NOTICE"]) this.getNotices();
      },
      deep: true
    },
    "modals.edit": {
      handler(val, oldVal) {
        if (!val) {
          this.selected.eNotice = {
            employee: {
              rol: {}
            },
            students: [],
            levels: [],
            groups: []
          };

          if (oldVal) {
            if (this.permits["WATCH_NOTICE"]) this.getNotices();
          }
        }
      },
      deep: true
    },
    getUser() {
      this.mapPermits();
      if (!this.permits["WATCH_NOTICE"]) {
        this.toast.failed = true;
      } else {
        if (this.notices.length == 0) {
          this.getNotices();
        }
      }
    }
  },
  filters: {
    noticeTypeFilter: function(type) {
      switch (type) {
        case "A":
          return "Aviso";
        case "E":
          return "Evento";
        case "P":
          return "Permiso";
        case "R":
          return "Reporte";
      }
    },
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  },
  data: () => ({
    dates: [],
    types: [],
    allowedDates: [],
    dateMenu: false,
    totalNotices: 0,
    pagination: {},
    notices: [],
    filters: {
      search: "",
      dates: [],
      typeNotice: []
    },
    flags: {
      loading: false
    },
    toast: {
      success: false,
      failed: false
    },
    modals: {
      createNotice: false,
      confirm: false,
      watch: false,
      edit: false,
      history: false
    },
    selected: {
      eNotice: {
        employee: {
          rol: {}
        },
        startDate: "",
        endDate: "",
        students: [],
        levels: [],
        groups: []
      },
      dNotice: {},
      wNotice: {
        employee: {
          rol: {}
        },
        students: [],
        levels: [],
        groups: []
      }
    },
    permits: []
  }),
  methods: {
    allowedDatesF(val) {
      var date = new Date(val);
      date.setSeconds(0);
      date.setMinutes(0);
      date.setHours(0);

      var flag = false;
      for (let t of this.allowedDates) {
        var date2 = new Date(t);
        date2.setSeconds(0);
        date2.setMinutes(0);
        date2.setHours(0);
        if (date2.getTime() === date.getTime()) {
          flag = true;
        }
      }
      return flag;
    },
    mapPermits() {
      var usr = this.getUser;
      var wbRol = usr.webRole;
      var catalogs = wbRol.catalogs;
      for (var c in catalogs) {
        if (catalogs[c].name.includes("NOTICE")) {
          this.permits[catalogs[c].name] = 1;

        }
      }
    },
    filterSearch() {
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {
      // 	search: val
      // });
      this.getNotices();
    },
    filterDate() {
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {
      // 	date: val
      // });
      this.getNotices();
    },
    filterType() {
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {
      // 	type: val
      // });
      this.getNotices();
    },
    getNotices() {
      this.flags.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      let pageSize = this.pagination.rowsPerPage == -1 ? this.totalNotices : this.pagination.rowsPerPage;
      let currentPage = this.pagination.page - 1;
      let offset = currentPage * pageSize;

      this.$store
        .dispatch("notice/getNotices", {
          offset: offset,
          size: pageSize,
          filters: this.filters
        })
        .then(response => {
          this.flags.loading = false;
          this.notices = response.data.entity;
          this.totalNotices = response.data.size;
          this.applyFilters(response.data.filters);
          this.$forceUpdate();
        })
        .catch(error => {
          console.log(error);
        });
    },
    applyFilters(newFilters) {
      if (this.filters.dates.length == 0) {
        this.allowedDates = [];
        for (const [index, item] of newFilters.dates.entries()) {
          this.allowedDates.push(item);
        }
        this.$forceUpdate();
      }
      if (this.filters.typeNotice.length == 0) {
        this.types = [];
        for (const [index, item] of newFilters.typeNotice.entries()) {
          switch (item) {
            case "A":
              this.types.push({ text: "Aviso", value: item });
              break;
            case "E":
              this.types.push({ text: "Evento", value: item });
              break;
            case "R":
              this.types.push({ text: "Reporte", value: item });
              break;
          }
        }
        this.$forceUpdate();
      }
    },
    cancelNotice(notice) {
      this.flags.loading = true;
      this.$store
        .dispatch("notice/cancelNotice", notice)
        .then(() => {
          this.flags.loading = false;
          this.toast.success = true;
          this.notices[this.notices.indexOf(notice)].cancelled = true;
        })
        .catch(error => {
          this.flags.loading = false;
          this.toast.failed = true;
          console.log(error);
        });
    },
    deleteNotice() {
      this.flags.loading = true;
      this.$store
        .dispatch("notice/deleteNotice", this.selected.dNotice)
        .then(response => {
          this.flags.loading = false;
          this.toast.success = true;
          this.getNotices();
          this.selected.dNotice = {};
        })
        .catch(error => {
          this.flags.loading = false;
          this.toast.failed = true;
          console.log(error);
        });
    },
    searchNotice(notice) {
      this.$store
        .dispatch("notice/getNotice", notice.id)
        .then(response => {
          this.viewNotice(response.data.entity);
        })
        .catch(() => {
        });
    },
    viewNotice(notice) {
      this.selected.wNotice = notice;
      this.modals.watch = true;
    },
    editNotice(notice) {
      this.selected.eNotice = notice;
      this.modals.edit = true;
    },
    historyNotice(notice) {
      this.selected.eNotice = notice;
      this.modals.history = true;
    },
    handleKeyDown(e) { //method to handle the keypress
      if (e.code === "Escape") {
        this.onCancel();
      }
    },
    onCancel() {
      this.modals.createNotice = false,
      this.modals.confirm = false,
      this.modals.watch = false,
      this.modals.edit = false,
      this.modals.history = false
      this.$forceUpdate();
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown); //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown); //will detach the event listener once the component is destroyed
  },
  computed: {
    momentFormatFirst() {
      if (this.filters.date != null && this.filters.date != "") {
        return moment(this.filters.date).format("DD/MM/YYYY");
      }
      return "";
    },
    forConfirmNotices() {
      return this.notices.filter(notice => {
        return !notice.confirm;
      });
    },
    ...mapGetters(["getUser"])
  }
};
</script>

<style>
.statusEvent {
  border-radius: 33px !important;
  height: 33px;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}

.v-data-iterator > .layout {
  max-height: 64vh;
  min-height: 64vh;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: rgba(239, 86, 91, 1) !important;
  scrollbar-color: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  scrollbar-color: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-width: thin;
}

.v-data-iterator > .layout::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #cccc;
  background-color: #cccc;
  border-radius: 10px;
}
.v-data-iterator > .layout::-webkit-scrollbar {
  width: 4px;
  background-color: #512e6f;
  display: block;
  opacity: 0;
}
.v-data-iterator > .layout::-webkit-scrollbar-thumb {
  background-color: #512e6f;
  border-radius: 10px;
  background-image: -webkit-linear-gradient(
    90deg,
    #ef565c 0%,
    #ef565c 25%,
    transparent 100%,
    #ef565c 75%,
    transparent
  );
}
</style>
